import { useMemo } from "react";
import { useClubScope } from "../contexts/ClubScopeContext";
import { validationBeltSystemKey } from "../utils/memberSport";
import {
  BJJ_BELT_PROGRESSION,
  getBeltProgressionOrder,
  isBeltRankUiConfigured,
} from "../utils/beltCatalog";
import {
  getStripePickerValues,
  sportUsesStripeRank,
} from "../utils/beltSystemCatalog";

export function buildValidationBeltSystemState(sport) {
  const validationKey = validationBeltSystemKey(sport);
  const effectiveKey = sport?.effectiveBeltSystemKey ?? null;
  const beltOrder =
    getBeltProgressionOrder(validationKey) ||
    getBeltProgressionOrder("bjj") ||
    BJJ_BELT_PROGRESSION;
  return {
    sport,
    validationKey,
    effectiveKey,
    beltRankConflict: Boolean(sport?.beltRankConflict),
    beltOrder,
    rankUiConfigured: isBeltRankUiConfigured(validationKey),
    sportUsesStripeRank: sportUsesStripeRank(validationKey),
    stripePickerValues: getStripePickerValues(validationKey),
  };
}

/**
 * Session member's belt validation system from /api/me (club-scoped via ?clubID=).
 */
export function useValidationBeltSystem() {
  const { apiMe, refreshApiMe } = useClubScope();
  const sport = apiMe?.sport;

  return useMemo(
    () => ({
      ...buildValidationBeltSystemState(sport),
      apiMeLoaded: apiMe != null,
      refreshApiMe,
    }),
    [apiMe, sport, refreshApiMe]
  );
}
